import React from 'react';
import PropTypes from 'prop-types';
import DaysLinks from './days-links';
import SelectPanel from './select-panel';
import TicketBuilderAccordion from './ticket-builder-accordion';
import { PRODUCT_TAG_CAR } from '../../../general/js/basket/constants';
import BackLink from './back-link';
import PopupLinkInfo from './popup-link-info';
import ButtonClear from './button-clear';
import { ROUTE_DAYS, SCENARIO_PARKING_STANDALONE } from './constants';
import { hasValue } from '../../../general/js/general-helpers';
import CurrencyHelper from '../../../general/js/basket/currency-helper';

export default class SelectParkingStandaloneForm extends React.Component {
    constructor(props) {
        super(props);
        this.formHeading = React.createRef();
    }

    componentDidMount() {
        this.formHeading.current.focus();
    }

    getPrevRoute() {
        let prevRoute = ROUTE_DAYS;

        if (this.props.currentScenario === SCENARIO_PARKING_STANDALONE) {
            prevRoute = ROUTE_DAYS;
        }

        return prevRoute;
    }

    generateParkingSummary() {
        const parkingTariff = this.props.productGroupsList.products.find((parking) =>
            parking.tag === PRODUCT_TAG_CAR);

        let text = '';

        if (parkingTariff) {
            text += `${CurrencyHelper.convertToPounds(parkingTariff.price)} ${parkingTariff.priceLabel}`;
        }

        return text;
    }

    getGroupParkingProducts(parkingProductsGroup) {
        const parkingList = this.props.parkingList;
        if (!parkingProductsGroup || !parkingProductsGroup.length || !parkingList || !parkingList.length) return null;

        var parkingListGroupProducts = new Array();
        parkingList.forEach((parkingProduct) => {
            if (parkingProductsGroup.some((product) => product.id === parkingProduct.id)) {
                parkingListGroupProducts.push(parkingProduct);
            }
        });

        return parkingListGroupProducts;
    }

    getFirstParkingProduct(parkingListGroupProducts) {
        if (!parkingListGroupProducts || !parkingListGroupProducts.length) return null;

        const parkingProduct = parkingListGroupProducts.filter((parkingProduct) =>
            parkingProduct.tag === PRODUCT_TAG_CAR)[0];

        if (parkingProduct) {
            return parkingProduct;
        }

        return parkingListGroupProducts[0];
    }

    renderParkingProductPanel(groupParkingProducts) {
        if (!groupParkingProducts || !groupParkingProducts.length) return null;

        const parkingListGroupProducts = this.getGroupParkingProducts(groupParkingProducts);
        const firstParkingProduct = this.getFirstParkingProduct(parkingListGroupProducts);

        return <SelectPanel
            dictionary={this.props.dictionary}
            key={firstParkingProduct.id}
            product={firstParkingProduct}
            productGroupsList={this.props.productGroupsList}
            onApplyProductsQuantity={this.props.onApplyProductsQuantity}
            rootCssClass='tb-panels-list__item'
        />;
    }

    renderParkingProductsPanels(parkingProductsList) {
        if (!parkingProductsList || !parkingProductsList.length) return null;

        return parkingProductsList.map((parkingProduct) => (
            <SelectPanel
                dictionary={this.props.dictionary}
                key={parkingProduct.id}
                product={parkingProduct}
                productGroupsList={this.props.productGroupsList}
                onApplyProductsQuantity={this.props.onApplyProductsQuantity}
                rootCssClass='tb-panels-list__item'
            />
        ));
    }

    renderAccordion(groupParkingProducts) {
        if (!groupParkingProducts || !groupParkingProducts.length || groupParkingProducts.length < 2) return null;

        const parkingListGroupProducts = this.getGroupParkingProducts(groupParkingProducts);
        if (!parkingListGroupProducts || !parkingListGroupProducts.length) return null;

        const firstParkingProduct = this.getFirstParkingProduct(parkingListGroupProducts);
        const accordeonParkingProducts = parkingListGroupProducts.filter((parkingProduct) =>
            parkingProduct !== firstParkingProduct);

        return (
            <TicketBuilderAccordion triggerText="See More Vehicles" triggerOpenedText="Show less vehicles">
                {this.renderParkingProductsPanels(accordeonParkingProducts)}
            </TicketBuilderAccordion>
        );
    }

    render() {
        return (
            <div className="tb-form">
                <h2 className="tb-form__heading headline" tabIndex="-1" ref={this.formHeading}>{this.props.dictionary.standaloneParkingStepTitle}</h2>
                <DaysLinks productGroupsList={this.props.productGroupsList} />
                <div className="tb-form__header">
                    <h2 className="title">{this.props.dictionary.standaloneParkingSubtitle}</h2>
                    {
                        hasValue(this.props.dictionary.standaloneParkingInformationLinkUrl) &&
                        hasValue(this.props.dictionary.standaloneParkingInformationLinkText) &&
                        <PopupLinkInfo
                            href={this.props.dictionary.standaloneParkingInformationLinkUrl}>{this.props.dictionary.standaloneParkingInformationLinkText}</PopupLinkInfo>
                    }
                </div>
                <div className="tb-form__list">
                    {this.props.productGroupsList.map((productGroup) => (
                        <React.Fragment key={productGroup.id}>
                            <h3 className="tb-form__group-title title">{productGroup.title}</h3>
                            {this.renderParkingProductPanel(productGroup.products)}
                            {this.renderAccordion(productGroup.products)}
                        </React.Fragment>
                    ))}
                </div>
                <div className="tb-form__footer">
                    <ButtonClear onClick={this.props.onClearSelection}>{this.props.dictionary.standaloneParkingClearSelectionText}</ButtonClear>
                    <div className="tb-form__footer-copy copy">
                        {this.props.dictionary.StandaloneParkingText}
                    </div>
                    <div className="tb-form__change-step">
                        <BackLink route={this.getPrevRoute()}>Back</BackLink>
                    </div>
                </div>
            </div>
        );
    }
}

SelectParkingStandaloneForm.propTypes = {
    dictionary: PropTypes.object.isRequired,
    parkingList: PropTypes.array,
    productGroupsList: PropTypes.array,
    currentScenario: PropTypes.string.isRequired,
    onApplyProductsQuantity: PropTypes.func,
    onClearSelection: PropTypes.func
};
